<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="immersion03">
    <NavBar />

    <div v-if="isWrongBrowser()">
      <h1>Bienvenue !</h1>
      <p>
        Oups, il semblerait que tu utilises un navigateur sur lequel notre site a du mal à fonctionner...
        <br />Pour jouer à ExploRêve, et plus généralement pour soutenir un développement libre d'internet, <br />nous
        t'invitons fortement à télécharger et utiliser Firefox, en allant
        <a href="https://www.mozilla.org/fr/firefox/new/">ici</a>
      </p>
      <img src="https://cdn.exploreve.fr/content/personnages/leon.svg" alt="leon" />
      <img src="https://cdn.exploreve.fr/content/personnages/daria.svg" alt="daria" />
      <img src="https://cdn.exploreve.fr/content/personnages/erwin.svg" alt="erwin" />
    </div>
    <div v-else>
      <div v-if="isMobile()">
        <h1>Bienvenue !</h1>
        <p>
          Pour entrer dans cette 3ème immersion, un ordinateur est nécessaire. En attendant, n'hésite pas nous rejoindre
          sur les réseaux sociaux, à parcourir le blog et à lire la page à propos pour en savoir plus sur le projet !
        </p>
        <img src="https://cdn.exploreve.fr/content/personnages/daria.svg" alt="daria" />
      </div>
      <router-view v-else />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from "@/components/NavBar.vue";

export default {
  name: "immersion04",
  components: {
    NavBar
  },
  methods: {
    isMobile: function () {
      return document.documentElement.clientWidth < 760;
    },

    isWrongBrowser: function () {
      const ua = window.navigator.userAgent;
      return ua.indexOf("Edge") !== -1 || ua.indexOf("Edg") !== -1 || ua.indexOf("MSIE") !== -1;
    }
  }
};
</script>

<style lang="scss" scoped>
.immersion03 {
  p {
    padding: 20px;
  }
  img {
    height: 300px;
    margin: auto;
    margin-bottom: 30px;
  }
  .volume-button {
    position: fixed;
    bottom: 50px;
    right: 0;
    margin: 30px;
    z-index: 500;
  }
}
</style>
